import {
    SET_TIME,
    START_QUIZ,
    RESUME_QUIZ,
    MARK_ANSWER,
    FINISH_QUIZ,
    SUBMIT_QUIZ,
    SELECT_ANSWER,
    SUBMIT_QUIZ_LOADING,
    VERIFY_ENROLLMENT_ID,
    VERIFY_ENROLLMENT_ID_LOADING,
} from '../types';

const initState = {
    total: 0,
    answer: "",
    course: "",
    quizId: "",
    answers: [],
    attempts: [],
    enrollmentId: "",
    questions: [],
    currentIndex: 0,
    questionTime: 0,
    isLoading: false,
    currentQuestion: null,
    submitQuizLoading: false,

    isQuizStarted: false,
    isQuizFinished: false,
    quizData: null,
    time: 0,
}

export default function reducer(state=initState, action) {
    let { type, payload } = action;
    switch (type) {
        case MARK_ANSWER: 
            return {
                ...state,
                time: payload.time,
                answers: payload.answers,
                attempts: payload.attempts,
                questionTime: payload.questionTime,
                currentIndex: state.currentIndex + 1,
                currentQuestion: payload.currentQuestion,
                isQuizStarted: payload.isQuizFinished ? false : state.isQuizStarted
            }

        case START_QUIZ: 
            return {
                ...state,
                answers: [],
                attempts: [],
                currentIndex: 0,
                time: payload.time,
                total: payload.total,
                questions: payload.questions,
                questionTime: payload.questionTime,
                currentQuestion: payload.currentQuestion,
                isQuizStarted: true,
                isQuizFinished: false,
                isLoading: false,
            }
        
        case RESUME_QUIZ: 
            return {
                ...state,
                answers: [],
                attempts: [],
                currentIndex: 0,
                time: payload.time,
                total: payload.total,
                questions: payload.questions,
                questionTime: payload.questionTime,
                currentQuestion: payload.currentQuestion,
                isQuizStarted: true,
                isQuizFinished: false,
                isLoading: false,
            }
        
        case FINISH_QUIZ:
            return {
                ...state,
                answers: [],
                attempts: [],
                time: 0,
                total: 0,
                course: "",
                questions: [],
                currentIndex: 0,
                questionTime: 0,
                isLoading: false,
                isQuizStarted: false,
                isQuizFinished: true,
                currentQuestion: null,
                submitQuizLoading: false,
                quizData: payload,
            }
        
        case SUBMIT_QUIZ:
            return {
                ...state,
                quizData: null,
                isLoading: false,
                isQuizFinished: true,
                submitQuizLoading: true,
            }

        case SUBMIT_QUIZ_LOADING:
            return {
                ...state,
                submitQuizLoading: payload,
            }

        case VERIFY_ENROLLMENT_ID: {
            return {
                ...state,
                isLoading: false,
                course: payload.course,
                enrollmentId: payload.enrollmentId
            }
        }

        case SELECT_ANSWER:
            return {
                ...state,
                answer: payload
            }

        case SET_TIME:
            return {
                ...state,
                time: payload
            }

        case VERIFY_ENROLLMENT_ID_LOADING:
            return {
                ...state,
                isLoading: payload
            }            

        default:
            return {state,
                    isLoading: false}
    }
}